<script lang="ts">
  import { ceiling, isVisited, medals } from '../core/engine';
  import { FAMOUS_NUMBERS } from '../core/famous';
  import { primesBetween } from '../core/numbers';
  import { fmt } from '../shared/lib/format';
  import { game } from '../shared/lib/game.svelte';

  const BLOCK = 100;
  const s = $derived(game.s);
  const lastBlock = $derived(Math.floor((ceiling(s) - 1) / BLOCK));
  let block = $state(Math.max(0, Math.floor((game.s.maxVisited - 1) / BLOCK)));
  const lo = $derived(block * BLOCK + 1);
  const hi = $derived((block + 1) * BLOCK);
  const primes = $derived(primesBetween(lo, hi));
  const famous = $derived([...FAMOUS_NUMBERS].sort((a, b) => a.n - b.n));
</script>

<section aria-labelledby="l-primes">
  <h2 id="l-primes">primes kept: <span class="num">{fmt(medals(s))}</span></h2>
  <p class="range">
    <button disabled={block === 0} onclick={() => block--}>earlier</button>
    <span class="num">{fmt(lo)}–{fmt(hi)}</span>
    <button disabled={block >= lastBlock} onclick={() => block++}>later</button>
  </p>
  <p class="primes num">
    {#each primes as p (p)}<span class:kept={p <= s.maxVisited}>{p}</span>{/each}
  </p>
</section>

<section aria-labelledby="l-famous">
  <h2 id="l-famous">numbers of note</h2>
  <ul>
    {#each famous as f (f.id)}
      {@const found = isVisited(s, f.n)}
      <li class:found>
        <span class="n num">{fmt(f.n)}</span>
        <span>{found ? `${f.name.toLowerCase()}. ${f.desc}` : '?'}</span>
      </li>
    {/each}
  </ul>
</section>

<style>
  section {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  section + section {
    margin-top: 28px;
  }
  h2 {
    font-size: 1.05rem;
    font-weight: 600;
    margin: 0;
  }
  .range {
    display: flex;
    align-items: baseline;
    gap: 16px;
    margin: 0;
  }
  .range button {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  .range button:disabled {
    color: var(--faint);
    text-decoration: none;
  }
  .primes {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.2em 0.7em;
    line-height: 1.7;
    color: var(--faint);
  }
  .primes .kept {
    color: var(--ink);
    font-weight: 600;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  li {
    display: flex;
    gap: 14px;
    color: var(--faint);
  }
  li.found {
    color: var(--ink);
  }
  .n {
    min-width: 3.6ch;
    text-align: right;
    flex: none;
  }
</style>
